import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Payment } from './payment';

 import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
	baseUrl = environment.baseUrl;
  private PaymentUrl = this.baseUrl + '/api/paymentdetails';  // URL to web api
  private invoiceUrl = this.baseUrl + '/api/paymentdetails/GetInvoicelistByPO'
 
   
  constructor( 
    private http: HttpClient
  ) { }
 
  getPayment (): Observable<Payment[]> {
	return this.http.get<Payment[]>(this.PaymentUrl)
  }
   GetPaymentDetails(paymentid: number): Observable<Payment> {
    const url = `${this.PaymentUrl}/${paymentid}`;
    return this.http.get<Payment>(url);
  }
  
  GetInvoiceByPO(poid: number): Observable<Payment> {
    const url = `${this.invoiceUrl}/${poid}`;
    return this.http.get<Payment>(url);
  }
 
  addPayment (payment: Payment): Observable<Payment> {
    return this.http.post<Payment>(this.PaymentUrl, payment, httpOptions);
  }
     
  deletePayment (payment: Payment | number): Observable<Payment> {
    const paymentid = typeof payment === 'number' ? payment : payment.paymentid;
    const url = `${this.PaymentUrl}/${paymentid}`;
 
    return this.http.delete<Payment>(url, httpOptions);
  }
 
  updatePayment (payment: Payment): Observable<any> {
    return this.http.put(this.PaymentUrl, payment, httpOptions);
  }

}